// define global window in case this is used in nodejs
/* global global */
if (typeof global !== 'undefined' && typeof window === 'undefined') {
  global.window = {
    location: {
      host: '',
      origin: '',
      pathname: '',
      href: '',
      hostname: '',
    },
    document: {
      querySelector: () => ({
        lang: '',
      }),
    },
    requestAnimationFrame: (callback) => {
      setTimeout(callback, 0);
    },
  };
}

const AIO_NAMESPACE = `micrositeaemheadless`;

const HOSTS = [
  {
    env: 'PROD',
    cdn: 'experienceleague.adobe.com',
    authorUrl: 'author-p122525-e1219150.adobeaemcloud.com',
    hlxPreview: 'main--exlm-prod--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm-prod--adobe-experience-league.hlx.live',
    appAssetsOrigin: `https://51837-${AIO_NAMESPACE}.adobeio-static.net`,
  },
  {
    env: 'STAGE',
    cdn: 'experienceleague-stage.adobe.com',
    authorUrl: 'author-p122525-e1219192.adobeaemcloud.com',
    hlxPreview: 'main--exlm-stage--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm-stage--adobe-experience-league.live',
    appAssetsOrigin: `https://51837-${AIO_NAMESPACE}-stage.adobeio-static.net`,
  },
  {
    env: 'DEV',
    cdn: 'experienceleague-dev.adobe.com',
    authorUrl: 'author-p122525-e1200861.adobeaemcloud.com',
    hlxPreview: 'main--exlm--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm--adobe-experience-league.hlx.live',
    appAssetsOrigin: `https://51837-${AIO_NAMESPACE}-stage.adobeio-static.net`,
  },
  {
    env: 'LOCAL',
    cdn: 'experienceleague-local.adobe.com',
    authorUrl: 'author-p122525-e1219192.adobeaemcloud.com',
    hlxPreview: 'main--exlm-stage--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm-stage--adobe-experience-league.live',
    appAssetsOrigin: 'https://experienceleague-local.adobe.com',
  },
];

export const currentHost = window.location.hostname;
export const defaultEnv = HOSTS.find((H) => H.env === 'STAGE');
export const currentEnv = HOSTS.find((H) => Object.values(H).includes(currentHost)) || {};

// Common domains mapping
const domains = {
  'experienceleague.adobe.com': 'https://experienceleague.adobe.com/',
  'experienceleague-stage.adobe.com': 'https://experienceleague-stage.adobe.com/',
  'experienceleague-dev.adobe.com': 'https://experienceleague-dev.adobe.com/',
};

export const getBaseUrl = () => {
  // Try to get parent URL if in iframe
  try {
    if (window.self !== window.top) {
      const hostname = window.parent.location.hostname;
      if (domains[hostname]) return domains[hostname];
    }
  } catch (e) {
    try {
      const hostname = new URL(document.referrer).hostname;
      if (domains[hostname]) return domains[hostname];
    } catch (error) {
      // Handle error properly
      console.error('Error accessing referrer:', error);
    }
  }

  // Use current hostname or default
  return domains[currentHost] || `https://${defaultEnv.cdn}/`;
};

export const baseUrl = getBaseUrl();
export const cdn = baseUrl && baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
export const appAssetsOrigin = currentEnv.appAssetsOrigin || defaultEnv.appAssetsOrigin;
